export const ERR_ACCOUNT_IS_LOCKED = 'account is locked'
